/**
 * @param {String} [message]
 * @param {Object<Function>} [actions]
 * @returns {jQuery}
 */
function ErrorMessage(message, actions) {

    message = message || L10N.getString('ERROR_UNDEFINED');
    if (!actions) {
        actions = {
            ACTION_RELOAD: function () {
                location.reload()
            }
        };
        message += '. ' + L10N.getString("PLEASE_RELOAD") + '.';
    }

    var $ = jQuery;
    var title = L10N.getString('ERROR');
    var error = $('<div class="ErrorMessage"><div class="message">' +
        '<h3></h3>' +
        '<p></p>' +
        '<ul class="buttons"></ul>' +
        '</div></div>');

    error.find('h3').text(title);
    error.find('p').text(message);

    var buttons = error.find('ul.buttons');
    for (var id in actions) {
        $('<li></li>')
            .text(L10N.getString(id))
            .click(actions[id])
            .appendTo(buttons);
    }

    return error;

}